import { useIntl } from "react-intl";
import { Divider } from "../../../BP2Components";

export const InfoTab = () => {
   const intl = useIntl();

   // Info tab added from designs, but we don't use it
   return (
      <>
         <div className="business-card__info-section">
            <h3 className="business-card__section-title">
               {intl.formatMessage({ id: "business.attractions" })}
            </h3>
            <ul className="business-card__section-list">
               <li>Kościół św. Piotra i Pawła (zabytkowy klasztor)</li>
            </ul>
         </div>

         <Divider className="business-card__divider" />

         <div className="business-card__info-section">
            <h3 className="business-card__section-title">
               {intl.formatMessage({ id: "business.contact" })}
            </h3>
            <ul className="business-card__social-list">
               <li>
                  <a href="https://example.com" target="_blank">
                     www.example.com
                  </a>
               </li>
               <li>Facebook: @example</li>
            </ul>
         </div>
      </>
   );
};
